<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			class="svg-inline--fa fa-folder-open"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 640"
		>
			<path
				class="solid"
				fill="currentColor"
				opacity=".4"
				d="M64.4 160L64.4 448C64.4 454.3 65.3 460.4 67 466.1C66.8 460.4 67.5 454.6 69.5 448.8L117.5 304.8C124 285.2 142.4 272 163 272L544.4 272L544.4 208C544.4 172.7 515.7 144 480.4 144L363.1 144C356.2 144 349.4 141.8 343.9 137.6L305.5 108.8C294.4 100.5 281 96 267.1 96L128.4 96C93.1 96 64.4 124.7 64.4 160z"
			></path>
			<path
				class="solid"
				fill="currentColor"
				d="M115 512L509.8 512C530.5 512 548.8 498.8 555.3 479.2L603.3 335.2C613.7 304.1 590.5 272 557.8 272L163 272C142.3 272 124 285.2 117.5 304.8L69.5 448.8C59.1 479.9 82.3 512 115 512z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { solidProps } from './Icon'
export default {
	name: 'FolderOpenIcon',
	components: { Icon },
	props: solidProps,
}
</script>
